import React, { Component } from "react";
import PropTypes from "prop-types";
import { connect } from "react-redux";
import { Modal, ModalBody } from "reactstrap";
import { bindActionCreators } from "redux";
import parseDomain from "parse-domain";
import merge from "deepmerge";

import * as surveyActionCreators from "../actions/surveyActionCreators";
import WizardComponent from "../components/WizardComponent";
import UrlKeyError from "../components/UrlKeyError";
import LanguageDropdown from "../components/LanguageDropdown";
import TakenVendorEmployeeIdError from "../components/TakenVendorEmployeeIdError";
import queryString from "query-string";
import { DEFAULT_WIZARD_FORM_VALUES } from "../constants/defaultValues";
import RomoLogo from "../assets/images/romo_logo_tall.jpg";
import NomadGcsLogo from "../assets/images/logo-centered.png";
import PrvaultLogo from "../assets/images/logo_PayrollVault.png";

const domainCustomizations = {
  romo: { themeName: "romo", logo: RomoLogo },
  "romo-staging": { themeName: "romo", logo: RomoLogo },
  "nomad-gcs": { themeName: "nomad-gcs", logo: NomadGcsLogo },
  "nomad-gcs-staging": { themeName: "nomad-gcs", logo: NomadGcsLogo },
  prvaultm: { themeName: "prvaultm", logo: PrvaultLogo },
  "prvaultm-staging": { themeName: "prvaultm", logo: PrvaultLogo },
  // "survey-staging": { themeName: "romo", logo: RomoLogo },
  "survey-staging": { themeName: "default", logo: "" },
  survey: { themeName: "default", logo: "" },
};

export class SurveyContainer extends Component {
  state = {
    showHelp: false,
    language: "english",
    userLanguage: null,
  };

  componentDidMount() {
    const { vendorEmployeeId, accessKeyId } = queryString.parse(
      this.props.location.search
    );
    this.props.actions.createEmployee(
      this.props.routeParams.employerURLKey,
      this.props.routeParams.locationURLKey,
      vendorEmployeeId,
      accessKeyId
    );
  }

  componentWillUnmount = () => {
    this.serverRequest.abort();
  };

  closeHelp = () => {
    this.setState({ showHelp: false });
  };

  openHelp = () => {
    this.setState({ showHelp: true });
  };

  changeLanguage = language => {
    this.setState({
      userLanguage: language,
      language,
    });
  };

  switchToEnglish = () => {
    this.setState({ language: "english" });
  };

  switchLanguageBack = () => {
    if (
      this.state.userLanguage &&
      this.state.userLanguage !== this.state.language
    ) {
      this.setState({ language: this.state.userLanguage });
    }
  };

  render() {
    const { data } = this.props;
    const { employee } = data;
    const { subdomain = "survey" } =
      parseDomain(window.location.href, {
        customTlds: ["localhost"],
      }) || {};
    const { themeName = "default", logo = "" } =
      domainCustomizations[subdomain] || {};
    const {
      allText: text,
      [themeName]: overrides = {},
    } = DEFAULT_WIZARD_FORM_VALUES;
    const allText = merge(text, overrides);
    const sharedText = allText[this.state.language].shared;
    const themeCx = `theme-${themeName}`;

    if (data.created === null) {
      return (
        <div className={`loadDiv ${themeCx}`}>
          <div className="loading" />
        </div>
      );
    } else if (data.created === false) {
      return (
        <div className={`container-fluid content-container ${themeCx}`}>
          {data.status === 409 ? (
            <TakenVendorEmployeeIdError />
          ) : (
            <UrlKeyError />
          )}
        </div>
      );
    }
    return (
      <div className={`container-fluid content-container ${themeCx}`}>
        <div className="row d-flex justify-content-between header-container">
          <div className="col-7 col-sm-6 col-md-4 col-xl-3 company-container">
            <div className="company">
              <span className="title">{employee.location.employer.name}</span>
              <span className="subtitle">{employee.location.name}</span>
            </div>
          </div>

          <div className="d-none d-md-block col-md-4 col-xl-6 justify-content-center semicircle-button-container">
            <div className="semicircle-button help" onClick={this.openHelp}>
              {"?"}
            </div>
          </div>

          <div className="col-5 col-sm-4 col-xl-3 language-container">
            <LanguageDropdown
              language={this.state.language}
              changeLanguage={this.changeLanguage}
              sharedText={sharedText}
            />
          </div>
        </div>

        <div className="wizard-container">
          <WizardComponent
            {...this.props}
            allText={allText}
            logo={logo}
            employee={employee}
            language={this.state.language}
            switchToEnglish={this.switchToEnglish}
            switchLanguageBack={this.switchLanguageBack}
            isDesktop={this.state.isDesktop}
            subdomain={subdomain}
          />
        </div>

        <Modal
          isOpen={this.state.showHelp}
          toggle={this.openHelp}
          modalClassName="help-dialog"
          size="lg"
        >
          <div className="semicircle-button-container">
            <div className="semicircle-button done" onClick={this.closeHelp}>
              {"×"}
            </div>
          </div>
          <ModalBody>
            <div className="text primary">
              {this.state.language === "english" && (
                <div className="information-modal">
                  <span className="main-information">
                    {
                      "Your responses are voluntary, confidential, and will not\
                    negatively affect your employment. The information you\
                    provide will be used only to qualify the company under this\
                    work opportunity program."
                    }
                  </span>
                </div>
              )}
              {this.state.language === "spanish" && (
                <span>
                  {
                    "Sus respuestas son voluntarias y se consideran\
                    confidenciales. No afectarán su empleo en ninguna manera\
                    negativa. Esta información se utilizará solo para calificar\
                    el negocio para este programa."
                  }
                </span>
              )}
            </div>
          </ModalBody>
        </Modal>
      </div>
    );
  }
}

function mapDispatchToProps(dispatch) {
  const actions = bindActionCreators(surveyActionCreators, dispatch);
  return {
    actions,
  };
}
function mapStateToProps(state) {
  return {
    data: state.$surveyStore,
  };
}

SurveyContainer.propTypes = {
  actions: PropTypes.object.isRequired,
  data: PropTypes.object.isRequired,
  location: PropTypes.object.isRequired,
  routeParams: PropTypes.object.isRequired,
};

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(SurveyContainer);



// WEBPACK FOOTER //
// ./src/containers/SurveyContainer.js